<template>
    <div class="relative size-full rounded-xs border border-gray-500 bg-gray-50 shadow-lg">
        <div class="absolute left-1/2 top-0 w-4 -translate-x-1/2 -translate-y-full
            border-x-8 border-b-8 border-x-transparent
            border-b-gray-500 sm:block">
        </div>

        <div id="tooltip"
            class="flex flex-col items-center justify-center p-sm">
            <div>
                <p class="text-left font-prenton-cond text-xl font-bold uppercase tracking-2xl">{{ t('title') }}</p>
            </div>

            <div v-for="item in parsedRatings"
                :key="item.rating"
                class="flex w-full flex-row items-center">
                <p class="pr-2">{{ item.rating }}</p>

                <v-icon class="fill-[#f6ca6c] stroke-brand-black"
                    icon="star" />

                <v-page-product-rating-chart
                    :count="item.count"
                    :total-rating-count="totalRatingCount"></v-page-product-rating-chart>
            </div>

            <v-button theme="black"
                size="sm"
                class="mt-xs uppercase">
                {{ t('read-all') }}
            </v-button>
        </div>
    </div>
</template>

<script setup lang="ts">
const properties = defineProps<{
    totalRatingCount: number
    skus: string[]
    ratings: ApiRatings
}>();

const { t } = useI18n();

/* eslint-disable @typescript-eslint/naming-convention */
interface ApiRatings {
    [key: number]: number
}

interface RatingItem {
    rating: number
    count: number
}
/* eslint-enable @typescript-eslint/naming-convention */

const parsedRatings = computed((): RatingItem[] => {
    const ratingsArray: RatingItem[] = [
        { rating: 1, count: 0 },
        { rating: 2, count: 0 },
        { rating: 3, count: 0 },
        { rating: 4, count: 0 },
        { rating: 5, count: 0 },
    ];

    // Iterate through the API ratings and update our ratings array
    for (const [key, value] of Object.entries(properties.ratings)) {
        const ratingToArray = Number.parseFloat(key);
        if (ratingToArray >= 1 && ratingToArray <= 5) {
            ratingsArray[ratingToArray - 1].count = value;
        }
    }

    return ratingsArray.reverse();
});
</script>

<style scoped>

</style>

<i18n lang="json">
    {
        "et": {
            "title": "Arvustused",
            "read-all": "Loe kõiki arvustusi"
        },
        "fi": {
            "title": "Arvostelut",
            "read-all": "Lue kaikki arvostelut"
        }
    }
</i18n>
